import { render, staticRenderFns } from "./U8interfacemangementtable.vue?vue&type=template&id=840a3a7a&scoped=true&"
import script from "./U8interfacemangementtable.vue?vue&type=script&lang=js&"
export * from "./U8interfacemangementtable.vue?vue&type=script&lang=js&"
import style0 from "./U8interfacemangementtable.vue?vue&type=style&index=0&id=840a3a7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a3a7a",
  null
  
)

export default component.exports